import { computed } from 'vue'
import { useApiStore } from '../stores/apiStore.js'

export function useReviews() {
  const apiStore = useApiStore()

  return {
    // Data
    reviews: computed(() => apiStore.reviews),
    loading: computed(() => apiStore.reviewsLoading),
    error: computed(() => apiStore.reviewsError),
    hasReviews: computed(() => apiStore.hasReviews),

    // Methods
    getByApartmentSlug: computed(() => apiStore.getReviewsByApartmentSlug),
    getByApartmentId: computed(() => apiStore.getReviewsByApartmentId),
    load: () => apiStore.loadReviews()
  }
}